function handleInvalidToken() {
  window.sessionStorage.setItem("secret", null);
  window.sessionStorage.setItem("permissions", null);
  window.location.href = "/login";
}

function handleCatchError(error) {
  if (error.code === 504) {
    handleInvalidToken();
  } else {
    throw error;
  }
}

function createAPI() {
  function get(path, withAuth=true) {
    return fetch(getPath(path), {
      method: "GET",
      headers: getHeaders(withAuth),
    })
      .then(getJson)
      .catch(handleCatchError);
  }

  function getDownloadFile(path, fileName="") {
    return fetch(getPath(path), {
      method: "GET",
      headers: getHeaders(true)
    })
    .then(async (res) => {
      if (res.status !== 200) {
        throw await res.json();
      }
      return res.blob()
    })
    .then(blob => {
      let url = window.URL.createObjectURL(blob);
      let aTag = document.createElement('a');
      aTag.href = url;
      aTag.download = fileName
      document.body.appendChild(aTag);
      aTag.click();
      aTag.remove();
    }).catch(handleCatchError);
  }

  function post(path, body, withAuth=true, headers, excludeJsonHeader=false) {
    return fetch(getPath(path), {
      method: "POST",
      headers: {...getHeaders(withAuth, !(body instanceof FormData)), ...headers},
      body: body instanceof FormData ? body : JSON.stringify(body),
      mode: "cors",
    })
      .then(getJson)
      .catch(handleCatchError);
  }

  function put(path, body, withAuth=true) {
    return fetch(getPath(path), {
      method: "PUT",
      headers: getHeaders(withAuth, !(body instanceof FormData)),
      body: JSON.stringify(body),
      mode: "cors",
    }).then(getJson)
    .catch(handleCatchError);
  }

  function getPath(path) {
    const API = process.env.REACT_APP_API_URL || 'https://api.sda.sociedadplus.com/sisa/api/';
    return `${API}${path}`;
  }

  function getHeaders(withAuth = false, isJsonFormat) {
    let authToken = "";
    if (withAuth) {
      authToken = window.sessionStorage.getItem("secret");
    }

    authToken = authToken?.replace(/"/gi, "");

    const headers = {
      ...(isJsonFormat && { "Content-Type": "application/json" }),
      ...(authToken && { Authorization: `Bearer ${authToken}` }),
      // "Access-Control-Request-Origin": "*"
    };

    return headers;
  }

  async function getJson(data) {
    if (data.status !== 200) {
      throw await data.json();
    } if (data.headers.get("content-type") === "application/pdf") {
      return await data.arrayBuffer();
    } else {
      return data.json();
    }
  }

  return {
    get,
    post,
    put,
    getDownloadFile
  };
}

export default createAPI();
